import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  DinkiLocale,
  LocaleOption,
  LocaleService,
} from 'src/app/services/locale.service';

/**
 * Sélecteur de langue compact pour la barre de navigation.
 *
 * <p>Affiche un bouton "drapeau + code langue" et ouvre un menu Material
 * permettant de basculer entre les langues supportées par Dinki.</p>
 */
@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, TranslateModule, MaterialModule, TablerIconsModule],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="langMenu"
      [matTooltip]="locale.currentLabel()"
      aria-label="Changer de langue"
    >
      <span class="text-lg">{{ locale.currentFlag() }}</span>
    </button>
    <mat-menu #langMenu="matMenu" class="!min-w-[180px]">
      <button
        mat-menu-item
        *ngFor="let lang of locale.available"
        (click)="select(lang.code)"
        [class.bg-primary]="lang.code === locale.current"
      >
        <span class="text-base me-2">{{ lang.flag }}</span>
        <span>{{ lang.label }}</span>
        <i-tabler
          *ngIf="lang.code === locale.current"
          name="check"
          class="size-4 ms-auto text-primary"
        ></i-tabler>
      </button>
    </mat-menu>
  `,
})
export class LanguageSwitcherComponent {
  locale = inject(LocaleService);

  select(code: DinkiLocale): void {
    this.locale.use(code);
  }
}
